var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};

OCS.Viewer.Classes.MouseEventMapFeature = new Class({
    drag_move: null,
    mouse_listeners_removal_timeout: null,
    mouse_listeners_removal_timeout_ms: 10000,
    mouse_move: null,
    mouse_position_event_key: null,
    mouse_over_map: false,
    mouse_listeners_active: false,
    mouse_position: null,

    init_mouse_events: function () {
        this.bound_events.pointermove = this.on_pointer_move.bind(this);
        this.bound_events.linkedpointermove = this.on_linked_pointer_move.bind(this);
        // Record the position of the mouse
        this.add_ol_event('pointermove', this.bound_events.pointermove);
        if (!this.mouse_move) {
            this.mouse_move = OCS.Viewer.Functions.get_utilities().create_throttled_method(function (e) {
                this.fireEvent("mouse_move", e, 1);
            }.bind(this), 150);
        }
        if (!this.drag_move) {
            this.drag_move = OCS.Viewer.Functions.get_utilities().create_throttled_method(function (e) {
                OCS.Viewer.Live.ControllerManager.map_move = true;
                this.fireEvent("drag_move", e, 1);
            }.bind(this), 150);
        }
        this.addEvent('mouse_listener', this.toggle_mouse_listener.bind(this));

        this.add_ol_event('pointerdrag', this.drag_move.bind(this));
        this.add_ol_event('moveend', this.on_move_end.bind(this));

    },
    on_move_end: function (event) {
        if (OCS.Viewer.Live.ControllerManager) {
            OCS.Viewer.Live.ControllerManager.map_move = false;
            this.fireEvent("move_end", event, 1);
            var mc = this.get_map_controller();
            if(mc) {
                mc.update_url_state();
            }
        }
    },
    on_pointer_move: function (event) {
        this.mouse_over_map = true;
        // Set the current position of the mouse
        this.mouse_position = event.coordinate;
        this.ol_object.set(this.options.mouse_position_string, event.coordinate);
        setTimeout(function () {
            // reset the mouse over map so that it will properly be handled later.
            this.mouse_over_map = false;
        }.bind(this), 145);
    },
    on_linked_pointer_move: function(event) {
        this.mouse_position = event.coordinate;
        this.ol_object.set(this.options.mouse_position_string, event.coordinate);
    },
    toggle_mouse_listener: function (condition) {
        if (condition !== null) {
            if (condition === this.mouse_listeners_active) {
                // No change
                return;
            }
        }

        if (!this.mouse_listeners_active) {
            this.add_mouse_listeners_to_map_canvas();
        } else {
            this.delay_remove_listeners_from_map_canvas();
        }
    },
    add_change_position_event: function (callback) {
        // Add an event on mouse position change that will call the back,
        //      Return back the key attached to this event that will be used to unregister it.

        return this.add_change_event(this.options.mouse_position_string, callback);
    },
    add_single_click_map_event: function (callback) {
        return this.add_ol_event(this.options.single_click_map_evnt, callback);
    },
    add_mouse_listeners_to_map_canvas: function () {
        if (this.mouse_listeners_removal_timeout) {
            clearTimeout(this.mouse_listeners_removal_timeout);
            this.mouse_listeners_removal_timeout = null;
        }
        if (!this.mouse_position_event_key) {
            this.mouse_position_event_key = this.add_change_position_event(this.mouse_move);
            this.mouse_click_event_key = this.add_single_click_map_event(this.mouse_click.bind(this));
            this.mouse_listeners_active = true;
        }
    },
    delay_remove_listeners_from_map_canvas: function () {
        if (!this.mouse_listeners_removal_timeout) {
            // Delay the removal by the time set in the class property, but do not delay it any more than that
            // Allowing for user interaction to add back a mouse interaction
            this.mouse_listeners_removal_timeout = setTimeout(this.remove_listeners_from_map_canvas.bind(this), this.mouse_listeners_removal_timeout_ms);
        }
    },
    remove_listeners_from_map_canvas: function () {
        if (this.mouse_listeners_removal_timeout) {
            clearTimeout(this.mouse_listeners_removal_timeout);
            this.mouse_listeners_removal_timeout = null;
        }
        if ((this.$events.mouse_click && this.$events.mouse_click.length) || (this.$events.mouse_move && this.$events.mouse_move.length)) {
            // Still have stuff tied to the mouse events
            return;
        }


        if (this.mouse_position_event_key || this.mouse_click_event_key) {
            this.remove_event(this.mouse_position_event_key);
            this.remove_event(this.mouse_click_event_key);
            this.mouse_position_event_key = null;
            this.mouse_click_event_key = null;
            this.mouse_listeners_active = false;
        }
    },
    mouse_click: function (e) {
        this.fireEvent("mouse_click", e, 1);
    },
    get_mouse_position: function () {
        // Retrieve the current mouse position in the map coordinates
        return this.ol_object.get(this.options.mouse_position_string);
    },
});
